import { SMART_CONTRACT_TYPES } from "@/components/SmartContractDesigner/smartContractPluginIDs";
import { DiagramValidationErrorModel } from "../config/DiagramValidationErrorModel";
import { DIAGRAM_ERROR_TYPES } from "../config/DiagramErrorTypes";

export function SCLoopMustHaveBodyValidaton(data) {
    const errors = [];
    data.currentPlugin.outgoing.map((connectorOutUuid) => data.diagramData.connectors.find(connector => connector.uuid === connectorOutUuid)).filter(connector => !!connector).filter(connector => {
        const plugin = data.diagramData.content.find(plugin => plugin.uuid === connector.to);
        return plugin.id === SMART_CONTRACT_TYPES.SMART_CONTRACT_DELIMITATOR;
    }).forEach(connector => {
        errors.push(new DiagramValidationErrorModel({
            type: DIAGRAM_ERROR_TYPES.LOOP_EMPTY_BODY,
            reason: "Loops has no content!",
            aditional: { emptyBodyLoopUuid: connector.from }
        }));
    });

    return errors.length === 0 ? true : errors;
}
